// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Kn-z","imageAndVideoCount":"Ln-z","imageAndVideoContainer":"Mn-z","viewAllReviews":"Nn-z"};